export default __webpack_public_path__ + "static/Greycliffcf-medium-webfont-aa94e81a1ee746b9d5bebf99a162d6cf.woff";